import { QueryString_F, ProductId, Route_pdata, execServiceApiSync, AutoLoginState, CPZSCheck, showQRcode, writeData,changeAutoLoginState } from '@/assets/js/fstsign.js'
import { ElMessageBox } from 'element-plus';

// author : xyl
// editdate : 20200901
// rem : 微信登录处理

/**
 * 微信登录检查，只被DLZSCheckAutoLogin调用
 * @param {String} cUrl 登录后跳转地址
 * @param {any} logoutPage 登录页面（重登录时或登录失效时跳转的页面）
 * @param {any} role 角色号
 * */
export function WeChatKeyLoginCheck(cUrl, logoutPage, role) {
    var retState = QueryString_F("state");//状态，扫码回调时存在。
    if (retState != null) {
        var checkcode = $.cookie("weChatExpired");
        if (checkcode == retState) {
            var weChatKey_ = QueryString_F("code");
            if ($.cookie("weChatReLogin") != "1") {
                weChatKeyLogin(weChatKey_, cUrl, logoutPage, role);
            }
            else {
                $.cookie("weChatReLogin", null, { path: '/' });
                weChatKeyReLogin(weChatKey_, cUrl, logoutPage, role);
            }
        }
        else {
            ElMessageBox.alert('二维码过期！', '提示信息', {
                confirmButtonText: '确定',
                type: 'error'
            })
        }
    }
}

/**
 * 根据微信返回的授权码登录。成功返回true,失败返回false，只被WeChatKeyLoginCheck调用
 * @param {string} weChatKey_ 微信授权码
 * @param {String} cUrl 登录后跳转地址
 * @param {any} logoutPage 登录页面（重登录时或登录失效时跳转的页面）
 * @param {any} role 角色号
 */
async function weChatKeyLogin(weChatKey_, cUrl, logoutPage, role) {
    var loginState = false;
    //var roleV = store.state.role;//获取角色类型
    var PSJ = JSON.stringify({ lx: "24", weChatKey: weChatKey_, pid: ProductId, role: role });
    var oRet = await execServiceApiSync(Route_pdata, "POST", PSJ); //向往登录，成功返回登录证书
    // 0登录成功；1添加登录证书失败；2添加产品证书失败，3存在用户登录证书,通知用户“登录未注销，是否注销重登录”
    if (oRet.retCode == "0") {
        changeAutoLoginState()
        // AutoLoginState = true;
        loginState = true;
        writeData(parseInt(oRet.nMinute), oRet.userData);
        CPZSCheck(cUrl, logoutPage);
        //redirectWindow(firstPage);
    }
    else
        if (oRet.retCode == "-1" || oRet.retCode == "1" || oRet.retCode == "2") {
            ElMessageBox.alert(oRet.Msg, '提示信息', {
                confirmButtonText: '确定',
                type: 'error'
            })
        }
        else
            if (oRet.retCode == "3") {
                ElMessageBox.confirm(
                    '登录未注销，请注销再扫码登录。',
                    '询问信息',
                    {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning',
                      'close-on-click-modal': false
                    }
                  )
                  .then(() => {
                    var dd = new Date();
                    dd.setTime(dd.getTime() + 120000);
                    $.cookie("weChatReLogin", "1", { path: '/', expires: dd });//标示当前使用扫码重登录
                    var divid = $.cookie("wxdivcookie");
                    if (divid != null && divid != "") {
                        showQRcode(divid);
                    }
                  }).catch(()=>{
                    
                  })
            }
            else {
                oRet.Msg = oRet.Msg || '未指定错误。';
                ElMessageBox.alert(oRet.Msg, '提示信息', {
                    confirmButtonText: '确定',
                    type: 'error'
                })
            }
    return loginState;
}

/**
 * 用户微信扫描登录时，如账号已登录，则注销重新登录。只被weChatKeyLogin调用。成功返回true,失败返回false
 * @param {string} weChatKey_ ">微信授权码 
 * @param {String} cUrl 登录后跳转地址
 * @param {any} logoutPage 登录页面（重登录时或登录失效时跳转的页面）
 * @param {any} role 角色号
 */
async function weChatKeyReLogin(weChatKey_, cUrl, logoutPage, role) {
    //var roleV = store.state.role;
    var PSJ = JSON.stringify({ lx: "25", weChatKey: weChatKey_, pid: ProductId, role: role });
    var oRet = await execServiceApiSync(Route_pdata, "POST", PSJ);
    // 0重登录成功；1添加登录证书失败；2添加产品证书失败，3删除登录证书失败
    if (oRet.retCode == "0") {
        changeAutoLoginState()
        // AutoLoginState = true;
        writeData(parseInt(oRet.nMinute), oRet.userData);
        //redirectWindow(firstPage);
        CPZSCheck(cUrl, logoutPage);
    }
    else
        if (oRet.retCode == "1") {
            ElMessageBox.alert('添加登录证书失败。', '提示信息', {
                confirmButtonText: '确定',
                type: 'error'
            })
        }
        else if (oRet.retCode == "2") {
            ElMessageBox.alert('添加产品证书失败。', '提示信息', {
                confirmButtonText: '确定',
                type: 'error'
            })
        }
        else if (oRet.retCode == "3") {
            ElMessageBox.alert('删除登录证书失败。', '提示信息', {
                confirmButtonText: '确定',
                type: 'error'
            })
        }
        else {
            oRet.Msg = oRet.Msg || '未指定错误。';
            ElMessageBox.alert(oRet.Msg, '提示信息', {
                confirmButtonText: '确定',
                type: 'error'
            })
        }
}


